<template>
  <div class="fotter">
    <div style="margin: 0 auto; box-sizing: border-box; padding: 35px 5%">
      <div style="margin-top: 22px;">
        <!-- <img style="" src="../img/logo.png" alt="" width="180"/> -->
      </div>
      <el-row class="f-state">
        <el-col :xs="24" :sm="20">
          <div class="f-state-t c-fff">
            <div>提升思考维度，优化创作品质，打造属于您的艺术资产。</div>
          </div>
        </el-col>
        <el-col :xs="24"  :sm="4">
          <div class="">
            <img src="../img/qrcode.png" alt="" srcset="" width="130" class="ma-t-10">
        </div>
        </el-col>
      </el-row>
      <!-- <div class="break">
        <div class="break-left">
          <div
            v-for="(lists,index) in list"
            :key="index"
            class="c-f"
            @click="toDetail(lists.path)"
          >
            {{ lists.Title }}
          </div>
        </div>
        <div class="break-right">
          <div class="break-right-first">
            网站备案号：沪-1221313 | 公安备案号：沪12313213
          </div>
          <div class="">版权所有@数智方舟</div>
        </div>
      </div> -->
    </div>
  </div>
</template>


<script>
// import { getfooter } from "../api.js";
export default {
  name: "Footer",

  data() {
    return {
      list: [
        { Id: "0", Title: "联系我们", path: "/contactus" },
      ],
      imgstatus: false,
    };
  },
  created() {},

  // beforeRouteLeave(to, from, next) {
  // 	console.log(to)
  // 	console.log(from)
  // 	next()
  // },
 

  methods: {
    toDetail(e) {
      this.$router.push({ path: e });
    },
    // 微博
    weib() {
      window.open("https://weibo.com/login.php", "_blank");
    },

    ewmshow() {
      this.imgstatus = !this.imgstatus;
    },

    qqs() {
      window.open(
        "tencent://AddContact/?fromId=50&fromSubId=1&subcmd=all&uin=875778812",
        "_blank"
      );
    },

    //跳转
    jumpdetail(e) {
      this.$router.push({ path: "/Explain", query: { code: e } });
    },

  },
};
</script>

<style  lang="scss" scoped>
.c-f {
  color: #fff !important;
}
.width200 {
  width: 200px;
}
.fotter {
  box-sizing: border-box;
  background-image: url(../img/footer-bg.png);
  background-size: cover;
  background-position: 100% 100%;
  // background:rgba(227,227,227,1);
  position: relative;
}
.f-state {
  padding-bottom: 16px;
  border-bottom: 1px solid #666666;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.fotter .f-state-t {
  font-size: 20px;
  width: 50%;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fff;
  margin-right: 40px;
  line-height: 28px;
}
.tk {
  .dberw {
    width: 94px;
    height: 94px;
    position: absolute;
    top: 10px;
  }
}
.brand {
  width: 540px;
  height: 33px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.brand .brand-s {
  padding: 0 70px;
  width: 180px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.brand-b:after {
  content: "|";
  display: block;
  width: 1px;
  height: 22px;
  color: #979797;
  position: absolute;
  right: 0;
}
.brand-b:before {
  content: "|";
  display: block;
  width: 1px;
  height: 22px;
  color: #979797;
  position: absolute;
  left: 0;
}
.break {
  padding-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.break .break-left {
  width: 40%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.break .break-left div {
  font-size: 12px;
  font-family: MicrosoftYaHei;
  color: rgba(102, 102, 102, 1);
  margin-right: 30px;
  cursor: pointer;
}
.break-right {
  width: 40%;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fff;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.break-right-first {
  font-size: 12px;
  font-family: MicrosoftYaHei;
  color: #fff;
  margin-right: 15px;
}
</style>
